// extracted by mini-css-extract-plugin
export var button = "_1p-0";
export var buttonContent = "_1p-e";
export var buttonGroup = "_1p-c";
export var dontRestrainIconWidth = "_1p-a";
export var dropdownButton = "_1p-b";
export var iconContainer = "_1p-9";
export var lg = "_1p-4";
export var md = "_1p-3";
export var pending = "_1p-f";
export var sm = "_1p-2";
export var spinner = "_1p-d";
export var squared = "_1p-8";
export var wrapText = "_1p-g";
export var xl = "_1p-5";
export var xs = "_1p-1";
export var xxl = "_1p-6";
export var xxxl = "_1p-7";